<template>
  <div>
    <top-bar voltar="admin/colaboradores"/>
    <menu-dash/>
    <div class="w3-main" style="margin-left:300px;margin-top:50px;">
      <formulario :editar="true"/>
      <div class="w3-small" style="margin: 0 16px">
        <div>
          <h6><b><i class="fa fa-exclamation-triangle"></i> Danger Zone</b></h6>
        </div>
        <br>
        <div class="w3-responsive w3-card w3-white w3-border w3-margin-bottom" style="min-height: 70px">
          <button type="button" class="w3-button w3-border primary w3-margin" @click="deletar">
            <i class="fa fa-trash-o"></i>
            <b>Deletar este colaborador</b>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import MenuDash from "../../commons/MenuDash.vue"
  import Formulario from "../../admin/colaborador/Formulario"

  export default {
    components: {TopBar, MenuDash, Formulario},
    data() {
      return {
        token: localStorage.getItem('key')
      }
    },

    methods: {
      deletar() {
        if (confirm("Deseja realmente deletar este colaborador?")) {
          openLoading("Deletando!");
          let usuario = this.$route.params.id;
          console.log(usuario);
          this.$http.get(base_url + 'usuarios/remover/' + usuario + '/' + this.token)
            .then(() => {
              closeLoading();
              openModalMsg("Sucesso","Colaborador deletado com sucesso!");
              this.$router.push('/admin/colaboradores');
            }, res => {
              closeLoading();
              openModalMsg(res.data.result,res.data.msg);
            });
        }
      }
    },

    mounted() {
    }
  }
</script>

<style scoped>
  .w3-centered tr td {
    padding: 13px;
  }

  .w3-table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/colaborador/AdminColaboradorEditar.vue